//
import endpoints from '../endpoints';
import WebMethodService from '../WebMethodService';

class MsgAPI {
  /**
   * Restituisce messaggi di default per eliminazione lista
   * @returns {Promise}
   */
  static getDefaultListValues() {
    const params = {};
    return WebMethodService.callWebMethod(endpoints.msg.getDefaultListValues, params);
  }
  
  /**
   * Restituisce elenco newsletter pubblicate
   * @param {number} idList 
   * @returns {Promise}
   * 
   */
  static getNewsletterList(idList) {
    const params = {
      idList
    };
    return WebMethodService.callWebMethod(endpoints.msg.getNewsletterList, params);
  }

  /**
   * Restituisce email del subscriber a partire da idUser e hash
   * @param {number} idUser 
   * @param {string} hash 
   * @returns {Promise}
   */
  static getSubscriberEmail(idUser, hash) {
    const params = {
      idUser,
      hash
    };

    return WebMethodService.callWebMethod(endpoints.msg.getSubscriberEmail, params);
  }

  /**
   * Restituisce true se subscriber è iscritto
   * @param {number} idList 
   * @param {number} idUser 
   * @param {string} hash 
   * @returns {Promise}
   */
  static isOptin(idList, idUser, hash) {
    const params = {
      idList,
      idUser,
      hash
    };

    return WebMethodService.callWebMethod(endpoints.msg.isOptin, params);
  }

  
  /**
   * Restituisce dati di un subscriber
   * @param {number} idList 
   * @param {number} idUser
   * @param {string}  hash
   * @returns {Promise}
   * 
   */
  static getSubscriberData(idList, idUser, hash) {
    const params = {
      idList,
      idUser,
      hash
    };
    return WebMethodService.callWebMethod(endpoints.msg.getSubscriberData, params);
  }


}

export default MsgAPI;